import { State } from '@/store/store'
export interface SosList {
  column: Array<{
    text: string
    value: string
    type?: string
    options?: {
      orderable?: boolean
      lengthLimit?: number
      filter?: boolean
      operation: string[],
    },
  }>
  defaultFilter: object
  itemCount: number
  page: number
  pageCount: number
  result: Array<{
    _id?: string;
    name: string;
    phone: number;
    createdAt?: number;
    updatedAt?: number;
  }>
}

export class SosState {
  public list: SosList
  constructor() {
    this.list = {
      column: [],
      itemCount: 0,
      page: 1,
      pageCount: 1,
      result: [],
      defaultFilter: {},
    }
  }
}

export interface ISos {
  _id: string,
  name: string,
  phone: string,
}

export default SosState
